import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import ReactFlagsSelect from "react-flags-select";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { addToCart } from "../../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Loader from "../../../components/loader/Loader";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

// Validation schema
const validationSchema = Yup.object({
  birthDate: Yup.date()
    .required("La date de naissance est requise")
    .max(new Date(), "La date de naissance ne peut pas être dans le futur"),
  birthCountry: Yup.string().required("Le pays est requis"),
  birthRegion: Yup.string().required("La région est requise"),
  birthDept: Yup.string().required("Le département est requis"),
  birthPlace: Yup.string().required("Le lieu est requis"),
});

// Données Cameroun : Régions et Départements
const countryRegionDepartmentData = {
  CM: {
    Adamaoua: ["Djérem", "Faro-et-Déo", "Mayo-Banyo", "Mbéré", "Vina"],
    Centre: [
      "Haute-Sanaga",
      "Lekié",
      "Mbam-et-Inoubou",
      "Mbam-et-Kim",
      "Méfou-et-Afamba",
      "Méfou-et-Akono",
      "Mfoundi",
      "Nyong-et-Kéllé",
      "Nyong-et-Mfoumou",
      "Nyong-et-So’o",
    ],
    Est: ["Boumba-et-Ngoko", "Haut-Nyong", "Kadey", "Lom-et-Djerem"],
    "Extrême-Nord": [
      "Diamaré",
      "Logone-et-Chari",
      "Mayo-Danay",
      "Mayo-Kani",
      "Mayo-Sava",
      "Mayo-Tsanaga",
    ],
    Littoral: ["Moungo", "Nkam", "Sanaga-Maritime", "Wouri"],
    Nord: ["Bénoué", "Faro", "Mayo-Louti", "Mayo-Rey"],
    "Nord-Ouest": [
      "Boyo",
      "Bui",
      "Donga-Mantung",
      "Menchum",
      "Mezam",
      "Momo",
      "Ngo-ketunjia",
    ],
    Ouest: [
      "Bamboutos",
      "Haut-Nkam",
      "Hauts-Plateaux",
      "Koung-Khi",
      "Menoua",
      "Mifi",
      "Ndé",
      "Noun",
    ],
    Sud: ["Dja-et-Lobo", "Mvila", "Océan", "Vallée-du-Ntem"],
    "Sud-Ouest": [
      "Fako",
      "Koupé-Manengouba",
      "Lebialem",
      "Manyu",
      "Meme",
      "Ndian",
    ],
  },
};

function PassportBirthPlace() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        ...values,
      })
    );

    navigate("/passport-residence-place");
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <Loader isLoading={submitting} />

      <div className="container mt-3 text-center" style={{ maxWidth: "800px" }}>
        <h4 className="text-center mt-4 mb-4">
          Quel est votre{" "}
          <span style={{ color: "#FF5500" }}>lieu de naissance</span> ?
        </h4>
      </div>

      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{
            birthDate: "",
            birthCountry: "",
            birthRegion: "",
            birthDept: "",
            birthPlace: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form
              className="w-100"
              style={{ textAlign: "left", maxWidth: "400px" }}
            >
              {/* Date de naissance */}
              <div className="mb-3">
                <label htmlFor="birthDate">Date de naissance</label>
                <Field
                  type="date"
                  name="birthDate"
                  className="form-control"
                  style={{ height: "50px" }}
                  max={new Date().toISOString().split("T")[0]}
                />
                {errors.birthDate && touched.birthDate && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.birthDate}
                  </div>
                )}
              </div>

              {/* Country selector */}
              <div className="mb-3">
                <label htmlFor="birthDate">pays de naissance</label>
                <ReactFlagsSelect
                  selected={values.birthCountry}
                  countries={["CM"]}
                  onSelect={(code) => {
                    setFieldValue("birthCountry", code);
                    setFieldValue("birthRegion", "");
                    setFieldValue("birthDept", "");
                  }}
                  placeholder="Pays de naissance"
                  searchable
                  searchPlaceholder="Recherchez le pays"
                  className="w-100"
                />
                {errors.birthCountry && touched.birthCountry && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.birthCountry}
                  </div>
                )}
              </div>

              {/* Region selector */}
              <div className="mb-3">
                <label htmlFor="birthDate">Region de naissance</label>
                <Select
                  options={
                    values.birthCountry
                      ? Object.keys(
                          countryRegionDepartmentData[values.birthCountry]
                        ).map((region) => ({ label: region, value: region }))
                      : []
                  }
                  value={
                    values.birthRegion
                      ? { label: values.birthRegion, value: values.birthRegion }
                      : null
                  }
                  onChange={(selected) => {
                    setFieldValue("birthRegion", selected.value);
                    setFieldValue("birthDept", "");
                  }}
                  placeholder="Région de naissance"
                  isDisabled={!values.birthCountry}
                  isSearchable
                />
                {errors.birthRegion && touched.birthRegion && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.birthRegion}
                  </div>
                )}
              </div>

              {/* Department selector */}
              <div className="mb-3">
                <label htmlFor="birthDate">departement de naissance</label>
                <Select
                  options={
                    values.birthRegion
                      ? countryRegionDepartmentData[values.birthCountry][
                          values.birthRegion
                        ].map((dep) => ({ label: dep, value: dep }))
                      : []
                  }
                  value={
                    values.birthDept
                      ? { label: values.birthDept, value: values.birthDept }
                      : null
                  }
                  onChange={(selected) =>
                    setFieldValue("birthDept", selected.value)
                  }
                  placeholder="Département de naissance"
                  isDisabled={!values.birthRegion}
                  isSearchable
                />
                {errors.birthDept && touched.birthDept && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.birthDept}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label htmlFor="birthDate">Lieu de naissance</label>
                <Field
                  name="birthPlace"
                  className="form-control"
                  placeholder="Lieu de naissance"
                  style={{ height: "50px" }}
                />
                {errors.birthPlace && touched.birthPlace && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.birthPlace}
                  </div>
                )}
              </div>

              {/* Submit button */}
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default PassportBirthPlace;
